import LocalizationHelperInstance from "./localizationHelper";
import { TranslationKeys } from "translations";

const StringHelper = {
  getFormattedMessageWithOptionalSuffix: (
    id: string,
    isOptional: boolean,
    defaultMessage?: string,
    values?: Record<string, string>
  ) => {
    const message = LocalizationHelperInstance.getFormattedMessage(id, defaultMessage, values);

    if (isOptional)
      return `${message} (${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Optional)})`;

    return message;
  },
};

export default StringHelper;
